import { render, staticRenderFns } from "./tabs-head.vue?vue&type=template&id=cec75520&"
import script from "./tabs-head.vue?vue&type=script&lang=js&"
export * from "./tabs-head.vue?vue&type=script&lang=js&"
import style0 from "./tabs-head.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.8.3@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports